import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import Layout from "../layout/Layout";
import "../../style/login/_login.scss";
import {useLoading} from "../components/loading/LoadingProvider";
import {nullToBlank} from "../utils/CommonUtil";
import {post} from "../utils/FetchUtil";
import {useAuth} from "../components/auth/AuthProvider.tsx";

interface FormData{
    auth_code?: string
    error_list?: [];
}

interface LoginCodeInputProps{}

const LoginCodeInputPage: React.FC<LoginCodeInputProps> = () => {
    const { login } = useAuth();
    const { showLoading, hideLoading, isLoading } = useLoading();
    const navigate = useNavigate();
    const [formData, setFormData] = useState<FormData>({});
    const [errorList, setErrorList] = useState([]);
    const [validated, setValidated] = useState(false);
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const {name, value} = event.target;
      setFormData({...formData, [name]: value});
    };
  const handleConfirmClick = async () =>{
      setValidated(true);
      const form = document.getElementById("loginCodeInputForm");
      // @ts-ignore
      if (!form.checkValidity()) {
          return;
      }
      setValidated(false);
      showLoading();
      post<LoginInfoDto>({
          action: "/api/login/code/valid",
          data: {auth_code: formData.auth_code}
      })
          .then((data) => {
              login(data);
              navigate("/");
          })
          .catch((reason) => {
              // @ts-ignore
              setErrorList([reason.message]);
          })
          .finally(() => {
              hideLoading();
          });
  }
  const handleBack = () => {
      navigate("/login");
  }
  return (
      <Layout page_meta = {{title: '認証コード入力｜ギフトアレンジ'}}
              error_list={errorList}
              show_footer={true}
      >
          <section className="container-fluid">
              <div className="row">
                  <div className="col-12">
                      <p className="login-title">
                          「オンラインギフトのギーバ」<br/>
                          楽天市場店データ入力サイト
                      </p>
                  </div>
              </div>
              <div className="row">
                  <div className="col"></div>
                  <div className="col-12 col-md-auto">
                      <div className="login-box">
                          このサイトは、「<strong>オンラインギフトのギーバ</strong>」<strong>の楽天市場店</strong>で、<br className="pc"/>
                          ギフトを注文いただいた方専用のデータ入力を行うサイトです。<br/>
                          <br/>
                          のし・包装やオンデマンドカードなどの包装資材に<strong>印刷するデータ入力</strong>や、<br className="pc"/>
                          無料の<strong>オンラインメッセージのデータ入力</strong>を御承りしております。
                      </div>
                      <div className="login-box input">
                          <p className="text-center mb-4">※メールに届いた６桁認証コードを入力してください。</p>
                          <form id="loginCodeInputForm" className={validated ? "form-group row w-100 was-validated" : "form-group row w-100"}>
                              <label htmlFor="auth_code" className="col-4 col-md-3 mt-4 col-form-label my-text-bold my-text-right">認証コード</label>
                              <div className="col-8 col-md-9 mt-4">
                                  <input type="text" maxLength={6} id="auth_code" className="form-control" name="auth_code" required value={nullToBlank(formData.auth_code)}
                                         onChange={handleInputChange}/>
                                  <div className="invalid-feedback">認証コードをご入力ください</div>
                              </div>
                          </form>
                          <div className="mt-4 d-flex justify-content-center align-items-center gap-5">
                              <button className="btn btn-secondary" onClick={handleBack}>戻 る</button>
                              <button className="btn btn-danger" onClick={handleConfirmClick} disabled={isLoading}>認証して進む</button>
                          </div>
                      </div>
                  </div>
                  <div className="col"></div>
              </div>
          </section>
      </Layout>
  );
};
export default LoginCodeInputPage;